import _get from "lodash/get";
import React from 'react';
import cn from 'classnames';
import { Price } from 'swag-common/utils/price';
import { capitalize } from 'swag-common/utils/strings';
import Image from 'swag-client-common/components/ui/image';
import classes from './product-card.scss';
export const ProductCard = ({
  product,
  isExpand,
  openRelatedProductBuilder
}) => {
  const {
    _id: productId,
    name,
    minPrice,
    maxPrice,
    minQuant,
    descriptionForWarehouse
  } = product;
  return /*#__PURE__*/React.createElement("figure", {
    onClick: () => openRelatedProductBuilder(product),
    className: cn(classes.container, {
      [classes.expandedProduct]: isExpand,
      [classes.hidden]: product.hidden
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: cn(classes.image, {
      [classes.expandedImg]: isExpand
    })
  }, /*#__PURE__*/React.createElement(Image, {
    src: _get(product, ['logoThumbnail', 'url']),
    alt: `${name} - ${descriptionForWarehouse}`,
    wrapperClassName: classes.imageWrapper,
    className: classes.imageLogo
  })), /*#__PURE__*/React.createElement("div", {
    className: cn(classes.info, {
      [classes.expandedInfo]: isExpand
    })
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.name,
    "data-product-id": productId
  }, capitalize(name)), /*#__PURE__*/React.createElement("div", {
    className: classes.specification
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: classes.fromTitle
  }, "From\xA0", /*#__PURE__*/React.createElement("span", {
    className: classes.price,
    "data-price": "FromPrice"
  }, Price.formatPrice(minPrice)), /*#__PURE__*/React.createElement("span", {
    className: classes.fromTitle
  }, "\xA0to\xA0"), /*#__PURE__*/React.createElement("span", {
    className: classes.price,
    "data-price": "ToPrice"
  }, Price.formatPrice(maxPrice)))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", {
    className: classes.fromTitle
  }, "Min Qty:"), /*#__PURE__*/React.createElement("span", {
    className: classes.price,
    "data-text": "Quantity"
  }, ' ', minQuant))))));
};